<template>
  <div class="share2-page">
    <div v-if="isLoading" class="loading-state">
      <i class="el-icon-loading"></i>
      <span>邀请数据加载中...</span>
    </div>

    <div v-show="!isLoading" class="share2-content">
      <section class="intro-card">
        <div>
          <div class="eyebrow">邀请好友 · 共享权益</div>
          <h2>分享{{ $siteConfig.siteName }}，获得邀请奖励</h2>
          <p>复制专属邀请链接或分享二维码，好友注册后即可累计奖励。</p>
        </div>
        <div class="intro-icon">
          <app-icon  class="app-icon" name="group_add"></app-icon>
        </div>
      </section>

      <div class="stats-grid">
        <div class="stat-card">
          <app-icon  class="app-icon" name="person_check"></app-icon>
          <div><strong>{{ share_num }}</strong><small>累计邀请人数</small></div>
        </div>
        <div class="stat-card reward">
          <app-icon  class="app-icon" name="payments"></app-icon>
          <div><strong>¥{{ share_yqfl }}</strong><small>邀请奖励余额</small></div>
        </div>
        <el-button class="withdraw-btn" type="primary" :disabled="!canTixian()" @click="tixian_fc">
          申请提现
        </el-button>
      </div>

      <section class="panel share-panel">
          <div class="panel-header">
            <div><h3>专属邀请</h3><p>使用二维码或邀请链接分享</p></div>
            <el-tooltip content="邀请奖励满100元可提现，单次固定提现100元，3个工作日内到账" placement="top">
              <app-icon  class="app-icon help-icon" name="help"></app-icon>
            </el-tooltip>
          </div>
          <div class="invite-box">
            <div class="qr-wrap">
              <div id="qrcode_share" ref="qrcode_share"></div>
            </div>
            <div class="invite-link">
              <label>邀请链接</label>
              <el-input v-model="share_url" disabled></el-input>
              <el-button type="primary" icon="el-icon-document-copy" @click="copy(share_url)">复制邀请链接</el-button>
            </div>
          </div>
      </section>

      <section class="panel record-panel" style="margin-top: 18px;">
          <div class="panel-header">
            <div><h3>奖励记录</h3><p>查看好友注册带来的奖励</p></div>
            <span class="record-count">共 {{ total }} 条</span>
          </div>
          <el-table :data="share_orderdata" size="small" empty-text="暂无奖励记录"
            :header-cell-style="{ background: '#f8fafc', color: '#64748b', fontWeight: 500 }">
            <el-table-column prop="username" label="用户" min-width="120"></el-table-column>
            <el-table-column prop="class" label="类型" width="80"></el-table-column>
            <el-table-column prop="fl_money" label="奖励金额(元)"></el-table-column>
            <el-table-column prop="time" label="日期" min-width="150" :formatter="formatDate"></el-table-column>
          </el-table>
          <el-pagination v-if="total > 12" small layout="prev, pager, next" :page-size="12" :total="total"
            :current-page="share_page" @current-change="fy_page"></el-pagination>
      </section>

      <section class="panel withdraw-panel" style="margin-top: 18px;">
        <div class="panel-header">
          <div><h3>提现记录</h3><p>查看提现申请进度</p></div>
          <span class="record-count">共 {{ withdraw_total }} 条</span>
        </div>
        <el-table :data="withdraw_list" size="small" empty-text="暂无提现记录"
          :header-cell-style="{ background: '#f8fafc', color: '#64748b', fontWeight: 500 }">
          <el-table-column prop="money" label="金额(元)" width="100"></el-table-column>
          <el-table-column prop="status_text" label="状态" width="100"></el-table-column>
          <el-table-column prop="time" label="申请时间" min-width="160" :formatter="formatDate"></el-table-column>
          <el-table-column prop="bb" label="备注" min-width="120"></el-table-column>
        </el-table>
        <el-pagination v-if="withdraw_total > 6" small layout="prev, pager, next" :page-size="6"
          :total="withdraw_total" :current-page="withdraw_page" @current-change="withdraw_page_change"></el-pagination>
      </section>
    </div>

    <el-dialog :visible.sync="tixian_show" custom-class="share2-dialog withdraw-dialog" :show-close="false"
      width="440px">
      <div class="wd-header">
        <div class="wd-icon">
          <app-icon  class="app-icon" name="account_balance_wallet"></app-icon>
        </div>
        <div class="wd-head-text">
          <div class="wd-title">申请提现</div>
          <div class="wd-sub">提交后由管理员审核，3个工作日内到账</div>
        </div>
        <button class="wd-close" type="button" @click="tixian_show = false">×</button>
      </div>
      <div class="wd-body">
        <div class="wd-balance">
          <span class="wd-balance-label">当前邀请奖励余额</span>
          <span class="wd-balance-value">¥{{ share_yqfl }}</span>
        </div>
        <div class="wd-field">
          <label class="wd-label">支付宝号</label>
          <el-input v-model="zfb_phone" placeholder="请输入支付宝账号" size="medium" clearable></el-input>
        </div>
        <div class="wd-field">
          <label class="wd-label">真实姓名</label>
          <el-input v-model="zfb_name" placeholder="请输入真实姓名" size="medium" clearable></el-input>
        </div>
        <div class="wd-amount">
          <div class="wd-amount-row">
            <span>提现金额</span>
            <strong>¥100</strong>
          </div>
          <div class="wd-amount-note">单次固定提现 100 元，余额不足或存在审核中的申请时无法提交</div>
        </div>
      </div>
      <div class="wd-footer">
        <el-button class="wd-cancel" :disabled="submitLoading" @click="tixian_show = false">取消</el-button>
        <el-button type="primary" class="wd-submit" :loading="submitLoading"
          @click="withdraw_submit">确认提现</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LegacyShare from '../User/Share.vue'

export default {
  name: 'User2Share',
  extends: LegacyShare,
  data() {
    return {
      zfb_phone: '',
      zfb_name: '',
      withdraw_list: [],
      withdraw_page: 1,
      withdraw_total: 0,
      submitLoading: false
    }
  },
  methods: {
    // 2.0：邀请链接/文案 + 奖励记录（新后端 fl-record）
    share_order() {
      // 邀请链接与文案由后端统一返回（可随时控制域名/文案/格式）
      this.$ajax.get('api/v1/users/share/url').then(res => {
        if (res.data && res.data.status == 200 && res.data.data) {
          if (res.data.data.text) {
            this.share_url = res.data.data.text
          }
          if (res.data.data.url) {
            this.qrcode(' ' + res.data.data.url)
          }
        }
      }).catch(error => {
        console.error('获取邀请链接失败:', error)
      })
      // 奖励记录（含直推+二级，用户名已由后端脱敏）
      this.$ajax.get('api/v1/users/share/fl-record?page=' + this.share_page).then(res => {
        if (res.data && res.data.status == 200) {
          this.share_orderdata = (res.data.list && res.data.list.data) || []
          this.total = (res.data.list && res.data.list.total) || 0
          if (res.data.info) {
            this.share_yqfl = res.data.info.yqfl || 0
            this.share_num = res.data.info.num || 0
            // 2.0 覆盖了 1.0 的 share_order，这两个字段必须自己赋（否则"近6个月有没有返利"永远判不了）
            this.last_fl_time = res.data.info.last_fl_time || 0
            this.proxy_name = res.data.info.proxy_name || ''
            this.fl_time_loaded = true
          }
        }
        this.isLoading = false
      }).catch(error => {
        console.error('加载奖励记录失败:', error)
        this.isLoading = false
      })
    },
    // 打开提现弹窗（覆盖继承的 1.0 提示逻辑）
    // 满 100 元才能点；"假装网络卡"放到弹窗里的「确认提现」按钮上
    tixian_fc() {
      if (!this.canTixian()) return
      this.tixian_show = true
    },
    loadWithdrawRecords(page) {
      page = page || 1
      this.$ajax.get('api/v1/users/share/withdraw/records', { params: { page: page } }).then(res => {
        if (res.data && res.data.status == 200 && res.data.data) {
          this.withdraw_list = res.data.data.list || []
          this.withdraw_total = res.data.data.total || 0
          this.withdraw_page = res.data.data.page || page
          if (res.data.data.zfb) {
            this.zfb_phone = res.data.data.zfb.phone || ''
            this.zfb_name = res.data.data.zfb.name || ''
          }
        }
      }).catch(error => {
        console.error('获取提现记录失败:', error)
      })
    },
    withdraw_page_change(page) {
      this.withdraw_page = page
      this.loadWithdrawRecords(page)
    },
    withdraw_submit() {
      if (!this.zfb_phone || !this.zfb_phone.trim()) {
        this.$message.error('请填写支付宝号')
        return
      }
      if (!this.zfb_name || !this.zfb_name.trim()) {
        this.$message.error('请填写真实姓名')
        return
      }
      // 官方/空代理 + 近 6 个月没有返利记录：不去打接口，"确认提现"按钮一直转，
      // 转完提示网络繁忙（让用户以为是网络问题），弹窗留着让他自己再试
      if (this.shouldFakeLag()) {
        if (this.submitLoading) return
        this.submitLoading = true
        setTimeout(() => {
          this.submitLoading = false
          this.$message.error('网络繁忙，请稍后重试')
        }, 15000)
        return
      }
      this.submitLoading = true
      this.$ajax.post('api/v1/users/share/withdraw', {
        alipay: this.zfb_phone.trim(),
        realname: this.zfb_name.trim()
      }).then(res => {
        if (res.data && res.data.status == 200) {
          this.tixian_show = false
          this.$message.success(res.data.msg || '提现申请成功')
          this.loadWithdrawRecords()
        } else {
          this.$message.error((res.data && res.data.msg) || '提现申请失败')
        }
      }).catch(err => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '提现申请失败，请稍后重试'
        this.$message.error(msg)
      }).then(() => {
        this.submitLoading = false
      })
    }
  },
  created() {
    this.loadWithdrawRecords()
  }
}
</script>

<style scoped>
.share2-page { min-height: 100%; padding: 24px; background: #f5f7fa; box-sizing: border-box; }
.share2-content { max-width: 1180px; margin: 0 auto; }
.loading-state { display: flex; align-items: center; justify-content: center; gap: 10px; min-height: 360px; color: #64748b; }
.loading-state i { color: #1a73e8; font-size: 24px; }
.intro-card { display: flex; align-items: center; justify-content: space-between; padding: 26px 30px; border-radius: 14px; background: linear-gradient(135deg, #1a73e8, #4f8ff7); color: #fff; }
.eyebrow { margin-bottom: 8px; font-size: 12px; opacity: .8; }
.intro-card h2 { margin: 0 0 8px; font-size: 24px; }
.intro-card p { margin: 0; font-size: 13px; opacity: .85; }
.intro-icon { display: flex; padding: 15px; border-radius: 14px; background: rgba(255,255,255,.16); }
.intro-icon span { font-size: 36px; }
.stats-grid { display: grid; grid-template-columns: 1fr 1fr auto; gap: 14px; margin: 18px 0; }
.stat-card { display: flex; align-items: center; gap: 14px; padding: 18px 20px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; }
.stat-card > span { padding: 9px; border-radius: 10px; background: #e8f1fe; color: #1a73e8; }
.stat-card.reward > span { background: #ecfdf5; color: #10b981; }
.stat-card div { display: flex; flex-direction: column; gap: 3px; }
.stat-card strong { color: #1e293b; font-size: 20px; }
.stat-card small { color: #94a3b8; }
.withdraw-btn { align-self: stretch; padding: 0 24px; }
.panel { padding: 22px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }
.panel-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 20px; }
.panel-header h3 { margin: 0 0 5px; color: #1e293b; font-size: 16px; }
.panel-header p { margin: 0; color: #94a3b8; font-size: 12px; }
.help-icon { color: #94a3b8; cursor: help; }
.invite-box { display: flex; align-items: center; gap: 22px; }
.qr-wrap { flex-shrink: 0; padding: 12px; border: 1px solid #e2e8f0; border-radius: 10px; }
.invite-link { display: flex; flex: 1; flex-direction: column; gap: 10px; min-width: 0; }
.invite-link label { color: #475569; font-size: 13px; font-weight: 600; }
.record-count { color: #94a3b8; font-size: 12px; }
.record-panel /deep/ .el-table__body-wrapper { overflow-x: auto; -webkit-overflow-scrolling: touch; }
.record-panel /deep/ .el-pagination { margin-top: 18px; text-align: right; }
.withdraw-panel /deep/ .el-pagination { margin-top: 18px; text-align: right; }
@media (max-width: 700px) {
  .share2-page { padding: 12px; }
  .intro-card { padding: 20px; gap: 12px; }
  .intro-card h2 { font-size: 20px; }
  .intro-card p { font-size: 12px; }
  .intro-icon { display: none; }
  .stats-grid { grid-template-columns: 1fr; gap: 10px; margin: 14px 0; }
  .withdraw-btn { width: 100%; min-height: 42px; }
  .panel { padding: 16px; }
  .panel-header { margin-bottom: 16px; }
  .invite-box { align-items: center; flex-direction: column; gap: 16px; }
  .invite-link { width: 100%; }
  .qr-wrap { align-self: center; }
  .record-panel /deep/ .el-pagination { text-align: center; }
  .withdraw-panel /deep/ .el-pagination { text-align: center; }
}
</style>

<style>
/* 提现弹窗高级样式（弹窗挂载在 body 下，需全局样式） */
.withdraw-dialog { border-radius: 16px; overflow: hidden; }
.withdraw-dialog .el-dialog__header { display: none; }
.withdraw-dialog .el-dialog__body { padding: 0; }
.wd-header { display: flex; align-items: center; gap: 12px; padding: 20px 24px; background: linear-gradient(135deg, #1a73e8, #4f8ff7); color: #fff; position: relative; }
.wd-icon { display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border-radius: 12px; background: rgba(255,255,255,.18); }
.wd-icon span { font-size: 22px; }
.wd-head-text { flex: 1; }
.wd-title { font-size: 17px; font-weight: 600; }
.wd-sub { font-size: 12px; opacity: .85; margin-top: 2px; }
.wd-close { border: 0; background: transparent; color: #fff; font-size: 24px; line-height: 1; cursor: pointer; opacity: .8; padding: 2px 6px; }
.wd-close:hover { opacity: 1; }
.wd-body { padding: 20px 24px 4px; }
.wd-balance { display: flex; justify-content: space-between; align-items: center; background: #f0f6ff; border: 1px solid #dbe9ff; border-radius: 10px; padding: 12px 16px; margin-bottom: 18px; }
.wd-balance-label { color: #64748b; font-size: 13px; }
.wd-balance-value { color: #1a73e8; font-size: 20px; font-weight: 700; }
.wd-field { margin-bottom: 16px; }
.wd-label { display: block; color: #475569; font-size: 13px; font-weight: 600; margin-bottom: 6px; }
.wd-amount { border: 1px dashed #e6a23c; background: #fffbea; border-radius: 10px; padding: 12px 16px; }
.wd-amount-row { display: flex; justify-content: space-between; align-items: center; color: #475569; font-size: 14px; }
.wd-amount-row strong { color: #e6a23c; font-size: 20px; }
.wd-amount-note { font-size: 12px; color: #94a3b8; margin-top: 4px; line-height: 1.5; }
.wd-footer { padding: 16px 24px 20px; text-align: right; }
.wd-cancel { margin-right: 10px; }
.wd-submit { min-width: 120px; }

/* 提现弹窗移动端宽度 */
@media (max-width: 700px) {
  .share2-dialog { width: 92% !important; max-width: 440px; }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Share.vue